<script>
import PageTitle from '@/components/layout/components/pageTitle'
import OrdersTable from '@/components/pages/orders/Table'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: {
        PageTitle,
        OrdersTable,
    },
    mixins: [AuthMixin],
    data() {
        return {
            total: null,
        }
    },
}
</script>

<template lang="pug">
div
    page-title {{ $t('orders.list_page_title') }}
        template(v-slot:append)
            span.page-title-subtitle(v-if="isSuperAdmin && total !== null") {{ total }}
    orders-table(@update:total="total = $event")
</template>
